export { default } from '@relo/sports-components/es/Tag';
export * from '@relo/sports-components/es/Tag';
